<template>
  <layout>

    <template slot="nav">
      <div class="hidden lg:block font-semibold mr-2">
        <router-link
          v-for="(link, index) in links"
          :key="index"
          :to="link.to"
          class="nav"
          active-class="current">
          {{ link.text }}
        </router-link>
      </div>
      <button class="lg:hidden p-2 focus:outline-none" @click.prevent="onToggleNav">
        <font-awesome-icon :icon="['far', 'bars']" size="lg" class="text-white cursor-pointer" />
      </button>
      <button @click="onSupervisorLogin" title="Start veileder" class="ml-2 bg-white inline py-1 px-2 uppercase rounded text-gray-700 shadow-md hover:shadow-lg focus:outline-none">
        <font-awesome-icon :icon="['far', 'user-friends']" class="text-sm" />
      </button>
    </template>

    <template slot="mobilenav" v-if="mobileNavVisible">
      <div class="container mx-auto pb-4">
        <router-link
          v-for="(link, index) in links"
          :key="index"
          :to="link.to"
          class="block">
          <div class="py-2 px-4 text-lg text-semibold" @click="mobileNavVisible = false">
            {{ link.text }}
          </div>
        </router-link>
      </div>
    </template>

    <router-view></router-view>

    <modal header="Veileder" @close="supervisorLoginVisible = false" v-if="supervisorLoginVisible">
      <div class="bg-blue-100 text-blue-800 p-4 border-2 border-blue-400 rounded-lg shadow">Veilederfunksjonen lar deg operere som om du var en praksiskoordinator, apotekkontakt eller kjedekontakt. Velg rolle og lokasjon, deretter skriv inn ditt passord.</div>
      <form class="mt-4" @submit.prevent="onSupervisorFormSubmit">

        <div>
          <div class="uppercase font-semibold text-sm text-gray-500">Rolle</div>
          <select class="w-full mt-1" v-model="selectedIdKey">

            <option v-for="(idKey, index) in idKeys" :key="index" :value="idKey.name">
              {{ idKey.text }}
            </option>
          </select>
        </div>


        <div class="mt-4" v-if="selectedIdKey === 'studentId'">
          <div class="uppercase font-semibold text-sm text-gray-500">Mobilnummer</div>
          <input type="text" v-model="selectedIdValue" autocomplete="do-not-autocomplete" />
        </div>

        <div class="mt-4" v-else>
          <div class="uppercase font-semibold text-sm text-gray-500">Lokasjon</div>
          <select class="w-full mt-1" v-model="selectedIdValue" :disabled="selectedIdKey === null">
            <option v-for="(item, index) in items" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>

        <div class="mt-4">
          <div class="uppercase font-semibold text-sm text-gray-500">Ditt passord</div>
          <input class="mt-1" name="password" id="password" type="password" v-model="password">
        </div>

        <div class="p-4 mt-6 bg-red-100 text-red-700 border-2 border-red-300 rounded-lg text-center shadow-lg" v-show="error">
          {{ error }}
        </div>

        <div class="mt-10">
          <button class="btn btn-primary" type="submit" :disabled="selectedIdValue === null || password === ''">Logg inn</button>
          <button class="btn ml-4" @click.prevent="onCancelSupervisor">Avbryt</button>
        </div>

      </form>
    </modal>
  </layout>
</template>

<script>
import api from '@/api'
export default {
  name: 'ap-layout',
  data () {
    return {
      supervisorLoginVisible: false,
      mobileNavVisible: false,
      error: null,
      password: '',
      idKeys: [
        { name: 'universityId', text: 'Praksiskoordinator' },
        { name: 'pharmacyId', text: 'Apotekkontakt' },
        { name: 'chainId', text: 'Kjedekontakt' },
        { name: 'studentId', text: 'Student' }
      ],
      selectedIdKey: null,
      selectedIdValue: null,
      items: [],
      links: [
        { to: '/af/forside', text: 'Forside' },
        { to: '/af/brukere', text: 'Brukere' },
        { to: '/af/valgperioder', text: 'Valgperioder' },
        { to: '/af/apotek', text: 'Apotek' },
        { to: '/af/studiesteder', text: 'Studiesteder' },
        { to: '/af/maler', text: 'Maler' }
      ]
    }
  },
  methods: {
    isCurrent (link) {
      return this.$route.path === link.to
    },
    onLogout () {
      this.$store.dispatch('logout')
      this.$router.push('/')
    },
    onSupervisorLogin () {
      this.supervisorLoginVisible = true
    },
    onSupervisorFormSubmit () {
      const username = `${this.$store.getters.user.email}|${this.selectedIdKey}:${this.selectedIdValue}${this.selectedIdKey === 'studentId' ? '@praksispoolen.no' : ''}`
      this.$store.dispatch('login', {
        username,
        password: this.password
      }).then(() => {
        const url = this.selectedIdKey === 'pharmacyId' ? '/ap/forside' :
                    this.selectedIdKey === 'universityId' ? '/pk/forside' :
                    this.selectedIdKey === 'chainId' ? '/kk/forside' :
                    this.selectedIdKey === 'studentId' ? '/st/forside' : ''
        if (url) {
          this.$router.push(url)
        } else {
          this.error = 'Ukjent bruker.'
        }
      }).catch(error => {
        this.error = error
      })
    },
    onCancelSupervisor () {
      this.supervisorLoginVisible = false
      this.password = ''
      this.selectedIdKey = null
      this.error = null
    },
    onToggleNav () {
      this.mobileNavVisible = !this.mobileNavVisible
    }
  },
  created () {
    this.$store.dispatch('me')
  },
  watch: {
    'selectedIdKey': async function (val) {
      this.selectedIdValue = null
      this.items = []
      switch(val) {
        case 'universityId':
          this.items = await api.getUniversities()
          break
        case 'pharmacyId':
          this.items = await api.getPharmacies()
          break
        case 'chainId':
          this.items = await api.getChains()
          break
      }
    }
  }
}
</script>

<style scoped>

.nav {
  @apply inline-block px-2 uppercase
}

.nav.current {
  @apply text-white
}

.nav:not(.current) {
  @apply text-red-300
}

.nav:hover {
  @apply underline
}

</style>

